import { createContext, useContext, type ReactNode } from 'react';

export type SystemMapNodeActions = {
  onResizeEnd: (nodeId: string, width: number, height: number) => void;
};

const SystemMapNodeActionsContext = createContext<SystemMapNodeActions | null>(null);

export function SystemMapNodeActionsProvider({
  value,
  children,
}: {
  value: SystemMapNodeActions;
  children: ReactNode;
}) {
  return (
    <SystemMapNodeActionsContext.Provider value={value}>{children}</SystemMapNodeActionsContext.Provider>
  );
}

export function useSystemMapNodeActions(): SystemMapNodeActions {
  const ctx = useContext(SystemMapNodeActionsContext);
  if (!ctx) {
    throw new Error('useSystemMapNodeActions must be used within SystemMapNodeActionsProvider');
  }
  return ctx;
}
